import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { translate } from '../Services/translation';
import { clearFilterApplied } from '../Actions/FacetedSearch.action';
class FacetedSearchClearButtonContainer extends Component {
  constructor(props) {
    super(props);
  }
  isFilterApplied(currentprops) {
    let result = false;
    currentprops.facetFilters.forEach(function (items) {
      if (result == false) {
        if (items != null && items.selectedOptions.length > 0) {
          result = true;
        }
      }
    });
    return result;
  }
  render() {
    const { clearFilterApplied } = this.props;
    return (
      this.isFilterApplied(this.props) == true && (
        <Fragment>
          <button className='button faceted-search--clear-button' onClick={(event) => clearFilterApplied()}>{translate('filter.clearfilter')}</button>
        </Fragment>
      )
    );
  }
}
const mapStateToProps = ({ facetedSearch: { facetFilters } }) => {
  return {
    facetFilters,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    clearFilterApplied: () => dispatch(clearFilterApplied())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FacetedSearchClearButtonContainer);